const Drayage = () => {
  return <div>Drayage</div>;
};

export default Drayage;
